import BlogCardList from "./BlogCardList"
import { useState } from "react"
import { ConditionalSnow, space6, BWHeader } from "../dist/helpers"

export default function Blog(props) {
  const [snowIsEnabled] = useState(false);
  const { dark } = props;

  return (
    <div>
      <center>
        { ConditionalSnow(snowIsEnabled) }
        { BWHeader(dark, "Blog", "Here you can checkout some of my recent projects / opeds") }
        <br/>
        <BlogCardList {...{dark}}/>
        { space6 }
        <br/>

      </center>
    </div>
  )
};
